<h1><a href="/admin-home">Admin</a> - Create a New Fleet Account</h1>
<section>
    <p>Fleet customer accounts are normally created "on the fly" as customers link into the VCM site from the Ford Fleet
        site. If a fleet customer calls the hotline having never visited the website, use this screen to create the
        Fleet's empty customer account. It will have blank contact information and will have no VCM serial numbers
        contained within.</p>
    <!-- <p>Once you enter the FIN code and click "Create Account", You will be positioned at the customer home page, working
        on behalf of the new customer's account.</p> -->
    <p><b>NOTE:</b> If there is already an account on file with the FIN code you provide, the existing account <b>WILL
            NOT BE OVERWRITTEN;</b> this is a safe action for existing fleets.</p>    
    <p>
        <label>FIN Code:
            <input type="text" id="finCode" [(ngModel)]="finCode" maxlength="6" size="10">
        <p class="errormsg">{{errormsg}}</p>
        <p class="msg">{{msg}}</p>
        </label>        
    </p>
    <button (click)="createAccount()">Create Account</button>
    <br><br>
</section>